import React from "react"
import styled from "styled-components"
import {
  DropdownSection,
  DropdownList,
  DropdownItem,
  Label
} from "./Components"

import ResourcesLogo from '../svg/Resources'
import DocumentationLogo from '../svg/Documentation'
import BlogLogo from '../svg/Blog'

const DevelopersDropdownEl = styled.div`
  width: 370px;
`

const Flex = styled.div`
  display: flex;
  > div:first-of-type {
    margin-right: 48px;
  }
`

const DevelopersDropdown = () => {
  return (
    <DevelopersDropdownEl>
      <DropdownSection data-first-dropdown-section>
        <DropdownItem
          logo={<ResourcesLogo size={48} />}
          title="Resource Library"
          description="See how the top enterprises tackle open source management"
          href="/resources"
          color="blue"
        />
        <DropdownItem
          logo={<DocumentationLogo size={48} />}
          title="Documentation"
          description="Learn how to integrate FOSSA into your organization"
          href="https://docs.fossa.com"
          color="blue"
        />
        <DropdownItem
          logo={<BlogLogo size={48} />}
          title="Blog"
          description="Keep up with the latest developments of FOSSA and the OSS ecosystem"
          href="/blog"
          color="blue"
        />
      </DropdownSection>
      <DropdownSection>
        <DropdownList>
          <li>
            <Label>Case Studies</Label>
          </li>
          <li><a href="/customers/zendesk/">Zendesk</a></li>
          <li><a href="/customers/smartthings/">SmartThings</a></li>
          <li><a href="/customers/js-foundation/">JS Foundation</a></li>
        </DropdownList>
      </DropdownSection>
    </DevelopersDropdownEl>
  )
}

export default DevelopersDropdown
